import {HttpClient} from '@angular/common/http';
import {inject, Injectable} from '@angular/core';
import {IBusinessPartner} from '@service-and-repairs/awpintegrationlib';
import {VehicleServiceContract} from '../interfaces/vehicle-service-contract';

@Injectable({
  providedIn: 'root'
})
export class ServiceContractService {
  private readonly httpClient: HttpClient = inject(HttpClient);

  getServiceContracts(vin: string,
                      locale: string,
                      country: string,
                      businessPartner: IBusinessPartner): Promise<VehicleServiceContract[]> {
    return new Promise((resolve, reject): void => {
      let url: string = `/api/service-contract/v2?vin=${vin}&locale=${locale}&country=${country}`;
      if (businessPartner) {
        url = url
          + `&distribution_partner_number=${businessPartner.getDistributionPartnerNumber()}`
          + `&outlet_number=${businessPartner.getOutletNumber()}`;
      }
      this.httpClient.get(url, {withCredentials: true})
        .subscribe({
          next: (response: any) => resolve(response.data),
          error: response => reject(response.errors)
        });
    });
  }
}
